import { useQuery } from '@apollo/react-hooks';
import { FormInput, FormInputProps } from 'modules';
import { DebtStatusListQuery } from 'queries/DebtStatus/DebtStatusData';
import React from 'react';

const DebtStatusSelect = (props: FormInputProps) => {
  const { data, loading } = useQuery(DebtStatusListQuery);

  const getOptions = () => {
    if (data && data.debtStatusList) {
      return data.debtStatusList
        .filter((s: GQL.IDebtStatus) => s.kod?.substr(0, 1) !== '_')
        .map((s: GQL.IDebtStatus) => {
          return {
            label: `${s.kod}: ${s.popis}`,
            value: s.id,
          };
        });
    }

    return [];
  };

  return (
    <FormInput
      {...props}
      type="select"
      placeholder={loading ? 'Načítám ...' : 'Vyberte ...'}
      disabled={loading}
      options={getOptions()}
    />
  );
};

export default DebtStatusSelect;
